var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"no-border"},[_c('ExchangeTabsDashboard',{scopedSlots:_vm._u([{key:"default",fn:function(slotProps){return [_c('h2',{staticClass:"title mb-32 pt-40 text-xs-center"},[_vm._v("\n        Profits and unrealised losses\n      ")]),_vm._v(" "),_c('BaseMarketTabsDashboard',{attrs:{"exchange":slotProps.exchange},scopedSlots:_vm._u([{key:"default",fn:function(slotProps){return [[_c('v-layout',{staticStyle:{"padding-top":"24px","padding-bottom":"20px"},attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('div',{staticClass:"text-xs-center base-currency"},[_vm._v("\n                  "+_vm._s(slotProps.base)+"\n                  "),(
                      _vm.recent_profits_per_base_currency &&
                        _vm.recent_profits_per_base_currency[
                          slotProps.exchange
                        ] &&
                        _vm.recent_profits_per_base_currency[slotProps.exchange][
                          slotProps.base
                        ]
                    )?_c('div',{staticClass:"display-2"},[_vm._v("\n                    "+_vm._s(_vm._f("roundMarketsFractionalAccountValue")(_vm.recent_profits_per_base_currency[slotProps.exchange][
                        slotProps.base
                      ].profit_week))+"\n                    "),_c('span',{staticClass:"profit-usd"},[_vm._v("\n                      USD\n                      "+_vm._s(_vm._f("roundNumber")(_vm.recent_profits_per_base_currency[slotProps.exchange][
                          slotProps.base
                        ].profit_week_usd,0))+"\n                      "),_c('v-icon',{staticClass:"vertical-align-middle icon-for-information",staticStyle:{"font-size":"14px","margin-left":"6px","margin-bottom":"1px"},on:{"click":[function($event){$event.stopPropagation();$event.preventDefault();},function () {
                            _vm.infoAlert(
                              _vm.$t('information.profit_worth_usd.title'),
                              _vm.$t('information.profit_worth_usd.description')
                            );
                          }]}},[_vm._v("fa-info-circle")])],1)]):_c('div',{staticClass:"display-2"},[_vm._v("\n                    0\n                    "),_c('span',{staticClass:"profit-usd"},[_vm._v("\n                      USD 0\n                      "),_c('v-icon',{staticClass:"vertical-align-middle icon-for-information",staticStyle:{"font-size":"14px","margin-left":"6px","margin-bottom":"1px"},on:{"click":[function($event){$event.stopPropagation();$event.preventDefault();},function () {
                            _vm.infoAlert(
                              _vm.$t('information.profit_worth_usd.title'),
                              _vm.$t('information.profit_worth_usd.description')
                            );
                          }]}},[_vm._v("fa-info-circle")])],1)]),_vm._v(" "),_c('div',{staticClass:"display-description"},[_vm._v("Last 7 days profit")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('div',{staticClass:"text-xs-center base-currency"},[_vm._v("\n                  "+_vm._s(slotProps.base)+"\n                  "),(
                      _vm.recent_profits_per_base_currency &&
                        _vm.recent_profits_per_base_currency[
                          slotProps.exchange
                        ] &&
                        _vm.recent_profits_per_base_currency[slotProps.exchange][
                          slotProps.base
                        ]
                    )?_c('div',{staticClass:"display-2"},[_vm._v("\n                    "+_vm._s(_vm._f("roundMarketsFractionalAccountValue")(_vm.recent_profits_per_base_currency[slotProps.exchange][
                        slotProps.base
                      ].profit_month))+"\n                    "),_c('span',{staticClass:"profit-usd"},[_vm._v("\n                      USD\n                      "+_vm._s(_vm._f("roundNumber")(_vm.recent_profits_per_base_currency[slotProps.exchange][
                          slotProps.base
                        ].profit_month_usd,0))+"\n                      "),_c('v-icon',{staticClass:"vertical-align-middle icon-for-information",staticStyle:{"font-size":"14px","margin-left":"6px","margin-bottom":"1px"},on:{"click":[function($event){$event.stopPropagation();$event.preventDefault();},function () {
                            _vm.infoAlert(
                              _vm.$t('information.profit_worth_usd.title'),
                              _vm.$t('information.profit_worth_usd.description')
                            );
                          }]}},[_vm._v("fa-info-circle")])],1)]):_c('div',{staticClass:"display-2"},[_vm._v("\n                    0\n                    "),_c('span',{staticClass:"profit-usd"},[_vm._v("\n                      USD 0\n                      "),_c('v-icon',{staticClass:"vertical-align-middle icon-for-information",staticStyle:{"font-size":"14px","margin-left":"6px","margin-bottom":"1px"},on:{"click":[function($event){$event.stopPropagation();$event.preventDefault();},function () {
                            _vm.infoAlert(
                              _vm.$t('information.profit_worth_usd.title'),
                              _vm.$t('information.profit_worth_usd.description')
                            );
                          }]}},[_vm._v("fa-info-circle")])],1)]),_vm._v(" "),_c('div',{staticClass:"display-description"},[_vm._v("Last 30 days profit")])])]),_vm._v(" "),(_vm.all_time_profits_per_base_currency)?_c('v-flex',{staticClass:"compare-box-left",attrs:{"xs12":"","md3":""}},[_c('div',{class:[
                    'text-xs-center',
                    'base-currency',
                    (_vm.allocationsUnrealisedLoss[slotProps.exchange] &&
                    _vm.allocationsUnrealisedLoss[slotProps.exchange][
                      slotProps.base
                    ]
                      ? _vm.allocationsUnrealisedLoss[slotProps.exchange][
                          slotProps.base
                        ]
                      : 0) <
                    (_vm.all_time_profits_per_base_currency &&
                    _vm.all_time_profits_per_base_currency[slotProps.exchange] &&
                    _vm.all_time_profits_per_base_currency[slotProps.exchange][
                      slotProps.base
                    ]
                      ? _vm.all_time_profits_per_base_currency[
                          slotProps.exchange
                        ][slotProps.base].profit_all
                      : 0)
                      ? 'green-bg round-left base-currency-margins'
                      : ''
                  ]},[_vm._v("\n                  "+_vm._s(slotProps.base)+"\n                  "),(
                      _vm.all_time_profits_per_base_currency &&
                        _vm.all_time_profits_per_base_currency[
                          slotProps.exchange
                        ] &&
                        _vm.all_time_profits_per_base_currency[
                          slotProps.exchange
                        ][slotProps.base]
                    )?_c('div',{staticClass:"display-2"},[_vm._v("\n                    "+_vm._s(_vm._f("roundMarketsFractionalAccountValue")(_vm.all_time_profits_per_base_currency[slotProps.exchange][
                        slotProps.base
                      ].profit_all))+"\n                  ")]):_c('div',{staticClass:"display-2"},[_vm._v("0")]),_vm._v(" "),_c('div',{class:[
                      'display-description',
                      (_vm.allocationsUnrealisedLoss[slotProps.exchange] &&
                      _vm.allocationsUnrealisedLoss[slotProps.exchange][
                        slotProps.base
                      ]
                        ? _vm.allocationsUnrealisedLoss[slotProps.exchange][
                            slotProps.base
                          ]
                        : 0) <
                      (_vm.all_time_profits_per_base_currency &&
                      _vm.all_time_profits_per_base_currency[
                        slotProps.exchange
                      ] &&
                      _vm.all_time_profits_per_base_currency[slotProps.exchange][
                        slotProps.base
                      ]
                        ? _vm.all_time_profits_per_base_currency[
                            slotProps.exchange
                          ][slotProps.base].profit_all
                        : 0)
                        ? 'green-color'
                        : ''
                    ]},[_vm._v("\n                    All time profit\n                  ")])])]):_vm._e(),_vm._v(" "),(_vm.all_time_profits_per_base_currency)?_c('v-flex',{staticClass:"compare-box-right",attrs:{"xs12":"","md3":""}},[_c('div',{staticClass:"image-block"},[(
                      (_vm.allocationsUnrealisedLoss[slotProps.exchange] &&
                      _vm.allocationsUnrealisedLoss[slotProps.exchange][
                        slotProps.base
                      ]
                        ? _vm.allocationsUnrealisedLoss[slotProps.exchange][
                            slotProps.base
                          ]
                        : 0) <
                        (_vm.all_time_profits_per_base_currency &&
                        _vm.all_time_profits_per_base_currency[
                          slotProps.exchange
                        ] &&
                        _vm.all_time_profits_per_base_currency[
                          slotProps.exchange
                        ][slotProps.base]
                          ? _vm.all_time_profits_per_base_currency[
                              slotProps.exchange
                            ][slotProps.base].profit_all
                          : 0)
                    )?_c('img',{staticClass:"compare-img",attrs:{"src":"/img/profit_more.svg"}}):_c('div',[(
                        _vm.allocationsUnrealisedLoss[slotProps.exchange] &&
                          _vm.allocationsUnrealisedLoss[slotProps.exchange][
                            slotProps.base
                          ]
                      )?_c('img',{staticClass:"compare-img",attrs:{"src":'/img/profit_less_' +
                          (_vm.themeDark ? 'dark' : 'light') +
                          '.svg'}}):_c('img',{staticClass:"compare-img",attrs:{"src":'/img/profit_more_' +
                          (_vm.themeDark ? 'dark' : 'light') +
                          '.svg'}})])]),_vm._v(" "),_c('div',{class:[
                    'text-xs-center',
                    'base-currency',
                    (_vm.allocationsUnrealisedLoss[slotProps.exchange] &&
                    _vm.allocationsUnrealisedLoss[slotProps.exchange][
                      slotProps.base
                    ]
                      ? _vm.allocationsUnrealisedLoss[slotProps.exchange][
                          slotProps.base
                        ]
                      : 0) <
                    (_vm.all_time_profits_per_base_currency &&
                    _vm.all_time_profits_per_base_currency[slotProps.exchange] &&
                    _vm.all_time_profits_per_base_currency[slotProps.exchange][
                      slotProps.base
                    ]
                      ? _vm.all_time_profits_per_base_currency[
                          slotProps.exchange
                        ][slotProps.base].profit_all
                      : 0)
                      ? 'green-bg round-right base-currency-margins'
                      : ''
                  ]},[_vm._v("\n                  "+_vm._s(slotProps.base)+"\n                  "),(
                      _vm.allocationsUnrealisedLoss[slotProps.exchange] &&
                        _vm.allocationsUnrealisedLoss[slotProps.exchange][
                          slotProps.base
                        ]
                    )?_c('div',{staticClass:"display-2"},[_vm._v("\n                    "+_vm._s(_vm._f("roundMarketsFractionalAccountValue")(_vm.allocationsUnrealisedLoss[slotProps.exchange][
                        slotProps.base
                      ]))+"\n                  ")]):_c('div',{staticClass:"display-2"},[_vm._v("0")]),_vm._v(" "),_c('div',{class:[
                      'display-description',
                      (_vm.allocationsUnrealisedLoss[slotProps.exchange] &&
                      _vm.allocationsUnrealisedLoss[slotProps.exchange][
                        slotProps.base
                      ]
                        ? _vm.allocationsUnrealisedLoss[slotProps.exchange][
                            slotProps.base
                          ]
                        : 0) <
                      (_vm.all_time_profits_per_base_currency &&
                      _vm.all_time_profits_per_base_currency[
                        slotProps.exchange
                      ] &&
                      _vm.all_time_profits_per_base_currency[slotProps.exchange][
                        slotProps.base
                      ]
                        ? _vm.all_time_profits_per_base_currency[
                            slotProps.exchange
                          ][slotProps.base].profit_all
                        : 0)
                        ? 'green-color'
                        : ''
                    ]},[_vm._v("\n                    Unrealised loss\n                    "),_c('v-icon',{staticClass:"vertical-align-middle icon-for-information",staticStyle:{"font-size":"14px","margin-left":"6px"},on:{"click":function () {
                          _vm.infoAlert(
                            _vm.$t('information.unrealised_losses.title'),
                            _vm.$t('information.unrealised_losses.description')
                          );
                        }}},[_vm._v("fa-info-circle")])],1)])]):_vm._e(),_vm._v(" "),(!_vm.all_time_profits_per_base_currency)?_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('div',{staticClass:"text-xs-center pa-3"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}}),_vm._v(" "),_c('h3',{staticClass:"loading-title"},[_vm._v("Loading profits...")])],1)]):_vm._e()],1)]]}}],null,true),model:{value:(_vm.activeTab[slotProps.exchange]),callback:function ($$v) {_vm.$set(_vm.activeTab, slotProps.exchange, $$v)},expression:"activeTab[slotProps.exchange]"}})]}}]),model:{value:(_vm.activeExchangeTab),callback:function ($$v) {_vm.activeExchangeTab=$$v},expression:"activeExchangeTab"}})],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3958b777","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/dashboard/BaseCurrencies.vue
// module id = Ypts
// module chunks = 0